import React from 'react';

import { ActionType, ActionTypeV2 } from '../api/types';
import { ReactComponent as DirectAnswerIconAsset } from '../assets/icons/direct-answer.svg';
import { ReactComponent as RephraseIcon } from '../assets/icons/direct-answer-rephrase.svg';
import { ReactComponent as SummarizeIcon } from '../assets/icons/direct-answer-summarize.svg';

import style from '../components/Answers/DirectAnswer/DirectAnswer.module.scss';

interface IconAndTooltip {
    icon: React.FunctionComponent<React.SVGProps<SVGSVGElement> & { title?: string }>;
    tooltip: string;
}

export const actionTypeToIcon: Record<ActionType, IconAndTooltip> = {
    [ActionType.SEARCH]: {
        icon: DirectAnswerIconAsset,
        tooltip: 'source.name.direct_answer',
    },
    [ActionType.SUMMARIZE]: {
        icon: SummarizeIcon,
        tooltip: 'action-bar.summarize.tooltip',
    },
    [ActionType.REPHRASE]: {
        icon: RephraseIcon,
        tooltip: 'action-bar.rephrase.tooltip',
    },
};

export const actionTypeToStyle: Record<ActionType | ActionTypeV2, string> = {
    [ActionType.SEARCH]: style.search,
    [ActionType.REPHRASE]: style.rephrase,
    [ActionType.SUMMARIZE]: style.summarize,
    [ActionTypeV2.CUSTOM]: style.custom,
};

export const isSearchShouldBeFocused = (action: ActionType | ActionTypeV2 | null) => {
    return action === null || action === ActionType.SEARCH;
};
